import { RelativeSpinner } from './RelativeSpinner';

type TProps = {
  overlay?: boolean;
  className?: string;
};

export const Spinner = ({ overlay = false, className = 'spinner-wrapper' }: TProps) => {
  return (
    <div className={['absolute z-[102] h-full w-full', className].filter(Boolean).join(' ')}>
      <RelativeSpinner className="relative-spinner" overlay={overlay} />
    </div>
  );
};
